import axios from "axios";
export const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
export const api = axios.create({ baseURL: API_URL, withCredentials: true });
export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e?.message || "Something went wrong";
}
